const getOrderedPaymentChannelRules = (paymentChannelRules) => {
  return paymentChannelRules
    .filter((rule) => rule.displayOrder)
    .sort((x, y) => x.displayOrder - y.displayOrder);
};

export { getOrderedPaymentChannelRules };
